import React, { FC, useContext, useMemo } from 'react'
import ErrorBoundary from '../components/system/ErrorBoundary'

import RouteContext from './RouteContext'

interface MatchRouteHandler {
  (route: string, segment: string): boolean,
}

interface MatchRouteHandlers {
  [name: string]: MatchRouteHandler,
}

type RouteProps = {
  segment: string,
  exact?: boolean,
  default?: boolean,
}

const MATCH_ROUTE_HANDLERS: MatchRouteHandlers = {
  exact: (route, segment) => route == segment,
  startsWith: (route, segment) => route.indexOf(segment) == 0,
}

const stripRoute = (route: string, segment: string): string => {
  if(!route) return ''
  const routeParts = route.split('.')
  const segmentParts = segment.split('.')
  return routeParts.slice(segmentParts.length).join('.')
}

const Route: FC<React.PropsWithChildren<RouteProps>> = (props) => {
  const def = props.default
  const {
    segment,
    exact,
    children,
  } = props
  const route = useContext(RouteContext)
  const doesMatch = useMemo(() => {
    if(def && !route) return true
    const handler = exact ? MATCH_ROUTE_HANDLERS.exact : MATCH_ROUTE_HANDLERS.startsWith
    return handler(route, segment)
  }, [
    def,
    route,
  ])

  if(!doesMatch) return null
  const newRoute = exact ? '' : stripRoute(route, segment)

  return (
    <RouteContext.Provider value={ newRoute }>
      <ErrorBoundary>
        { children }
      </ErrorBoundary>
    </RouteContext.Provider>
  )
}

export default Route